<template>
  <div class="gap-1 flex flex-col text-left">
    <span
      v-if="label"
      class="text-sm font-medium text-[#7C7C7C] mb-1"
      :class="labelClass"
      >{{ label }}</span
    >

    <div class="relative">
      <select
        :value="value"
        class="w-full py-2 px-4 bg-white border border-[#E8E8E8] outline outline-1 outline-transparent rounded-3xl h-[50px] cursor-pointer text-gray-900 appearance-none pr-12"
        :class="{
          '!outline-[#7C7C7C]': isFocused && !isInvalid,
          '!outline-error': isFocused && isInvalid,
          '!border-error': isInvalid,
          'text-[#D0D0D0]': !value
        }"
        @change="handleChange"
        @focus="isFocused = true"
        @blur="isFocused = false"
      >
        <option value="" disabled>
          {{ $t('languageSelect.placeholder') }}
        </option>
        <option
          v-for="language in sortedLanguages"
          :key="language.englishName"
          :value="language.englishName"
        >
          {{ language.flag }} {{ language.name }} ({{ language.englishName }})
        </option>
      </select>

      <BaseIcon
        icon="angle-down"
        class="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-900 pointer-events-none"
      />
    </div>

    <span v-if="isInvalid" class="text-xs text-error mt-1">{{
      errors[0]
    }}</span>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'
import { languages } from '@/utils/languages.js'

export default {
  name: 'BaseLanguageSelect',

  components: { BaseIcon },

  props: {
    label: { type: String, default: '' },
    labelClass: { type: String, default: '' },
    value: { type: String, default: '' },
    errors: { type: Array, default: () => [] }
  },

  data: () => ({
    isFocused: false,
    languages: languages
  }),

  computed: {
    isInvalid() {
      return this.errors.length
    },

    sortedLanguages() {
      return [...this.languages].sort((a, b) =>
        a.englishName.localeCompare(b.englishName)
      )
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue && !this.languages.find(lang => lang.code === newValue)) {
          console.warn(`Language with code "${newValue}" not found`)
        }
      }
    }
  },

  methods: {
    handleChange(event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
